/* Nukka Care — interactions des sections nk-* (sans dépendance) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    var fmt = (window.nkMoneyFormat || '{{amount}} CHF');
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  };

  /* ---------- Toast (confirmation / erreur) ---------- */
  var toastEl, toastTimer;
  function toast(msg, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nk-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('nk-toast--error', !!isError);
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Ajout au panier ---------- */
  function addToCart(variantId, quantity, button) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    }
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }

    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          throw new Error(res.json.description || res.json.message || 'Erreur');
        }
        var label = button && button.getAttribute('data-added-label');
        toast(label || 'Ajouté au panier');
        if (drawer && res.json.sections) {
          var state = res.json.items && res.json.items[0] ? Object.assign({}, res.json.items[0]) : {};
          state.sections = res.json.sections;
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.json }));
      })
      .catch(function (err) {
        toast(err.message && err.message !== 'Erreur' ? err.message : "L'article n'a pas pu être ajouté. Réessayez ou contactez-nous.", true);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var scope = btn.closest('[data-nk-buy]');
    var variantId = btn.getAttribute('data-variant-id');
    var qty = btn.getAttribute('data-quantity') || 1;
    if (scope) {
      var checked = scope.querySelector('input[data-nk-offer]:checked');
      if (checked) { variantId = checked.value; qty = checked.getAttribute('data-quantity') || 1; }
    }
    if (variantId) addToCart(variantId, qty, btn);
  });

  /* ---------- Offres Solo / Duo / Trio ---------- */
  function syncOffers(scope) {
    var checked = scope.querySelector('input[data-nk-offer]:checked');
    if (!checked) return;
    var price = Number(checked.getAttribute('data-price'));
    var compare = Number(checked.getAttribute('data-compare') || 0);
    var available = checked.getAttribute('data-available') === 'true';
    var name = checked.getAttribute('data-name') || '';
    scope.querySelectorAll('.nk-offer').forEach(function (l) { l.classList.toggle('is-selected', !!l.querySelector('input:checked')); });
    scope.querySelectorAll('[data-nk-offer-price]').forEach(function (el) { el.textContent = money(price); });
    scope.querySelectorAll('[data-nk-offer-compare]').forEach(function (el) {
      el.textContent = compare > price ? money(compare) : '';
      el.hidden = !(compare > price);
    });
    scope.querySelectorAll('[data-nk-offer-name]').forEach(function (el) { el.textContent = name; });
    scope.querySelectorAll('[data-nk-add]').forEach(function (b) {
      var lbl = b.querySelector('.nk-btn__label');
      if (lbl) lbl.textContent = available ? (b.getAttribute('data-label') || 'Ajouter au panier') + (b.hasAttribute('data-no-price') ? '' : ' · ' + money(price)) : 'Indisponible';
      if (!available) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    var sticky = document.querySelector('[data-nk-sticky]');
    if (sticky && scope.hasAttribute('data-nk-main')) {
      sticky.querySelectorAll('[data-nk-offer-price]').forEach(function (el) { el.textContent = money(price); });
      sticky.querySelectorAll('[data-nk-offer-name]').forEach(function (el) { el.textContent = name; });
    }
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[data-nk-offer]')) return;
    var scope = e.target.closest('[data-nk-buy]');
    if (scope) syncOffers(scope);
  });

  /* ---------- Galerie (défilement tactile + miniatures) ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-nk-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nk-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nk-thumb]'));
    var counter = root.querySelector('[data-nk-counter]');
    if (!track || !slides.length) return;
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var prev = root.querySelector('[data-nk-prev]'), next = root.querySelector('[data-nk-next]');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-nk-prev]'), next = root.querySelector('[data-nk-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(Math.max(0, Math.min(slides.length - 1, i)));
        ticking = false;
      });
    }, { passive: true });
    setActive(0);
  }

  /* ---------- Repères interactifs (zones du coussin) ---------- */
  function initZones(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-nk-zone]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-nk-zone-panel]'));
    function select(id, focusPanel) {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-nk-zone') === id;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-nk-zone-panel') === id;
        p.classList.toggle('is-active', on);
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { select(b.getAttribute('data-nk-zone')); });
    });
    if (buttons[0]) select(buttons[0].getAttribute('data-nk-zone'));
  }

  /* ---------- Barre d'achat mobile ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-nk-sticky]');
    var target = document.querySelector('[data-nk-sticky-target]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer, .nk-footer');
    var targetVisible = true, footerVisible = false, targetAbove = false;
    function update() {
      var show = !targetVisible && targetAbove && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('nk-has-sticky', show);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        targetVisible = en.isIntersecting;
        targetAbove = en.boundingClientRect.top < 0;
      });
      update();
    }).observe(target);
    if (footer) new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting; update();
    }).observe(footer);
    update();
  }

  /* ---------- Apparitions ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.nk-reveal');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ---------- Onglets (craintes) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    function select(i, focus, scroll) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
      // seulement sur action de l'utilisateur, et seulement horizontalement dans la rangée d'onglets
      if (scroll) {
        var row = tabs[i].parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: tabs[i].offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false, true); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true, true); }
      });
    });
    if (tabs.length) select(0);
  }

  /* ---------- Vidéos d'étapes : lecture muette quand visibles ---------- */
  function initAutoVideos(root) {
    var vids = root.querySelectorAll('.nk-steps__media video');
    if (!vids.length || reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) en.target.play().catch(function () {}); else en.target.pause(); });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- Date de réception estimée (jours ouvrés, samedi/dimanche exclus) ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return d;
  }
  function formatDelivery(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (!(min > 0) || !(max >= min)) return;
    var today = new Date();
    var a = addBusinessDays(today, min), b = addBusinessDays(today, max);
    var dayFmt = { weekday: 'long', day: 'numeric' };
    var fullFmt = { weekday: 'long', day: 'numeric', month: 'long' };
    var first = a.getMonth() === b.getMonth() ? a.toLocaleDateString('fr-CH', dayFmt) : a.toLocaleDateString('fr-CH', fullFmt);
    el.textContent = 'Reçu entre le ' + first + ' et le ' + b.toLocaleDateString('fr-CH', fullFmt);
    el.setAttribute('data-nk-delivery-done', '');
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-nk-delivery]:not([data-nk-delivery-done])').forEach(formatDelivery);
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length) { initDelivery(document); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Panier : remplacer le Solo par le Duo ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-swap]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var updates = {};
    updates[btn.getAttribute('data-remove')] = 0;
    updates[btn.getAttribute('data-add')] = 1;
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = drawer && btn.closest('cart-drawer');
    var body = { updates: updates };
    if (inDrawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true');
    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || 'Erreur');
        if (inDrawer && res.json.sections) {
          var state = Object.assign({}, res.json.items && res.json.items[0] ? res.json.items[0] : {});
          state.sections = res.json.sections;
          drawer.renderContents(state);
          toast('Pack Duo ajouté à la place du Solo');
        } else {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.json }));
      })
      .catch(function () {
        toast("Le changement n'a pas pu être fait. Réessayez ou contactez-nous.", true);
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled');
      });
  });

  function init(root) {
    root = root || document;
    initDelivery(root);
    root.querySelectorAll('[data-nk-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-nk-zones]').forEach(initZones);
    root.querySelectorAll('[data-nk-buy]').forEach(syncOffers);
    root.querySelectorAll('[data-nk-tabs]').forEach(initTabs);
    initAutoVideos(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initSticky();
    initReveal();
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initReveal();
    initSticky();
  });

  window.NukkaCare = { addToCart: addToCart, toast: toast };
})();
